module.exports = __webpack_public_path__ + "img/t4-i21.981f7368.jpg";